import type { SemanticColor } from '../../shared/components/semanticColor';
import type { ProjectType, ValidationDecision, ValidationRecommendation } from '../../core/types/data-models';

type Display = { label: string; color: SemanticColor };

/**
 * How the summary's recommendation reads on screen, per project type. The
 * values are the same four on the backend; a founder reads them as go /
 * pivot / no-go, an investor as invest / dig deeper / pass, a stock
 * investor as buy / buy below a price / hold / sell.
 */
const IDEA_RECOMMENDATION: Record<ValidationRecommendation, Display> = {
  GO: { label: 'Go', color: 'success' },
  CONDITIONAL_GO: { label: 'Conditional go', color: 'warning' },
  PIVOT: { label: 'Pivot', color: 'warning' },
  NO_GO: { label: 'No go', color: 'error' },
};

const BUSINESS_RECOMMENDATION: Record<ValidationRecommendation, Display> = {
  GO: { label: 'Invest', color: 'success' },
  CONDITIONAL_GO: { label: 'Invest with conditions', color: 'warning' },
  PIVOT: { label: 'Dig deeper', color: 'warning' },
  NO_GO: { label: 'Pass', color: 'error' },
};

const STOCK_RECOMMENDATION: Record<ValidationRecommendation, Display> = {
  GO: { label: 'Buy', color: 'success' },
  CONDITIONAL_GO: { label: 'Buy below a price', color: 'warning' },
  PIVOT: { label: 'Hold', color: 'warning' },
  NO_GO: { label: 'Sell', color: 'error' },
};

/** How the recorded decision reads on screen, per project type. */
const IDEA_DECISION: Record<ValidationDecision, Display> = {
  GO: { label: 'Go', color: 'success' },
  PIVOT: { label: 'Pivot', color: 'warning' },
  NO_GO: { label: 'No go', color: 'error' },
};

const BUSINESS_DECISION: Record<ValidationDecision, Display> = {
  GO: { label: 'Invest', color: 'success' },
  PIVOT: { label: 'Dig deeper', color: 'warning' },
  NO_GO: { label: 'Pass', color: 'error' },
};

const STOCK_DECISION: Record<ValidationDecision, Display> = {
  GO: { label: 'Buy', color: 'success' },
  PIVOT: { label: 'Hold', color: 'warning' },
  NO_GO: { label: 'Sell', color: 'error' },
};

export function recommendationDisplayFor(projectType: ProjectType): Record<ValidationRecommendation, Display> {
  if (projectType === 'BUSINESS_VALIDATION') return BUSINESS_RECOMMENDATION;
  if (projectType === 'STOCK_VALIDATION') return STOCK_RECOMMENDATION;
  return IDEA_RECOMMENDATION;
}

export function decisionDisplayFor(projectType: ProjectType): Record<ValidationDecision, Display> {
  if (projectType === 'BUSINESS_VALIDATION') return BUSINESS_DECISION;
  if (projectType === 'STOCK_VALIDATION') return STOCK_DECISION;
  return IDEA_DECISION;
}
